document.addEventListener('DOMContentLoaded', function () {
    var countdownElements = document.querySelectorAll('.special-offers__countdown-box');

    countdownElements.forEach(function (countdownElement) {
        var serverTime = parseInt(countdownElement.getAttribute('data-server-time'), 10);
        var endDate = parseInt(countdownElement.getAttribute('data-end-date'), 10);

        if (isNaN(serverTime) || isNaN(endDate)) {
            console.error("Niepoprawne wartości czasu!");
            return;
        }

        function updateCountdown() {
            serverTime += 1000;
            var timeLeft = endDate - serverTime;

            var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
            var hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

            var countdownId = countdownElement.id.split('-')[1];
            countdownElement.querySelector('#days-' + countdownId + ' .special-offers__countdown-value').textContent = days;
            countdownElement.querySelector('#hours-' + countdownId + ' .special-offers__countdown-value').textContent = hours;
            countdownElement.querySelector('#minutes-' + countdownId + ' .special-offers__countdown-value').textContent = minutes;
            countdownElement.querySelector('#seconds-' + countdownId + ' .special-offers__countdown-value').textContent = seconds;

            if (timeLeft < 0) {
                clearInterval(countdownInterval);
                countdownElement.innerHTML = "<span class='bgc-gray-e7e fz fz--16-18 fw-semibold special-offers__infospan'>Promocja zakończona</span>";
            }
        }

        var countdownInterval = setInterval(updateCountdown, 1000);
        updateCountdown();
    });
});
